export { default } from './EquipmentList';
